import React, { useState } from 'react';
import { solutionTabs } from '../data/mock';

const SolutionTabs = () => {
  const [activeTab, setActiveTab] = useState('air-freight');

  return (
    <section className="bg-slate-900 py-4 sticky top-20 z-40 border-y border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-center gap-1 flex-wrap">
          {solutionTabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-4 py-2.5 text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap ${
                activeTab === tab.id
                  ? 'bg-amber-500 text-slate-900'
                  : 'text-slate-400 hover:text-white hover:bg-slate-800'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolutionTabs;
